import { useQuery } from '@hooks/reactQuery';

import { getRUDashboardStates } from '@api/ruStatusDashboard';

import { extractQueryParams } from '@utils/common';

import { IRUDashboardStatusDTO } from '@interfaces/ruStatusDashboard/dto/ruStatusDashboardDTO';
import { IRUStatusDashboard } from '@interfaces/ruStatusDashboard/ruStatusDashboard';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { RU_DASHBOARD_STATUSES } from '@constants/queryKeys';

interface IUseQueryRUDashboardStatusReturned {
	ruDashboardStatus: IRUStatusDashboard[];
	countOfRecords: number;
	isLoadingRUDashboardStatus: boolean;
}

export const useQueryRUDashboardStatus = (
	params: IRUDashboardStatusDTO,
): IUseQueryRUDashboardStatusReturned => {
	const {
		data,
		isFetching,
		isLoading,
	} = useQuery({
		queryKey: [RU_DASHBOARD_STATUSES, params],
		queryFn: extractQueryParams(getRUDashboardStates),
		allowedRoles: [
			EUserRoles.smoLightUpdater,
			EUserRoles.smoLightViewer,
		],
		enabled: [params.page, params.pageSize],
		...refetchOptions,
	});

	return {
		ruDashboardStatus: data?.items || [],
		countOfRecords: data?.count || 0,
		isLoadingRUDashboardStatus: (isLoading && !!data) || isFetching,
	};
};
